export default __webpack_public_path__ + "static/media/Ballroll_00271.91e3f3bd.png";